import React, { HTMLProps, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { isFuture } from 'date-fns';
import { Event } from 'modules/events/types/eventsTypes';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { unregisterFromAnEvent, registerForAnEvent } from 'modules/events/services/eventsService';
import { fetchEventsAction } from 'modules/events/store/eventsActions';
import { addNotificationAction } from 'store/notifications/notificationsActions';

type EventsActionButton = HTMLProps<HTMLButtonElement> & {
  event: Event;
  detailsView?: boolean;
  onRegister?: () => void;
};

export const EventsActionButton: FC<EventsActionButton> = ({
  event: { id, connectionLink, userRegistered, eventDate },
  detailsView = false,
  onRegister = null,
  ...rest
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const upcoming = isFuture(new Date(eventDate));

  const handleAction = () => {
    const updateRegistrationStatus = userRegistered
      ? unregisterFromAnEvent(id as string)
      : registerForAnEvent(id as string);

    updateRegistrationStatus
      .then(() => {
        dispatch(
          addNotificationAction({
            message: `Successfully ${
              userRegistered ? 'unregistered from' : 'registered to'
            } an event!`,
            variant: 'success',
          }),
        );
        dispatch(fetchEventsAction());
        if (onRegister) {
          onRegister();
        }
      })
      .catch((error: any) => {
        dispatch(
          addNotificationAction({
            message: error.message,
            variant: 'error',
          }),
        );
      });
  };

  const showAccessButton = userRegistered && ((upcoming && !detailsView) || !upcoming);
  let label = upcoming ? 'Get started' : 'View recording';

  if (showAccessButton) {
    return (
      <Button
        variant="contained"
        // @ts-ignore
        color="primary"
        component="a"
        target="_blank"
        href={connectionLink}
        {...rest}
        disabled={!connectionLink}
      >
        {t(label)}
      </Button>
    );
  }

  if (upcoming) {
    label = userRegistered ? 'Unregister' : 'Register';
  } else {
    label = 'Access recording';
  }

  return (
    <Button
      variant="contained"
      // @ts-ignore
      color="primary"
      onClick={handleAction}
      {...rest}
    >
      {t(label)}
    </Button>
  );
};
